module.exports = __webpack_public_path__ + "static/media/mailnews_13.f6c31c37.ico";